import HyperLink from '@acorn-portal/shared/src/components/hyperlink';
import { Typography } from '@mui/material';
import { IFooterDetail } from '@acorn-portal/shared/src/components/footer';

export const FooterDetails: IFooterDetail[] = [
	{
		title: 'Terms of Business',
		content: (
			<Typography
				component='a'
				href='https://www.mypolicy.co.uk/docs/policy-documents/haven/terms-of-business.pdf'
				target='_blank'
				rel='noreferrer'
				sx={{ color: 'white' }}
			>
				Our Terms of Business
			</Typography>
		),
	},
	{
		title: 'Registered Office Details',
		content: (
			<Typography>
				My Policy is a trading name of Acorn Insurance and Financial Services Limited who is authorised and regulated by
				the Financial Conduct Authority (FCA) under the Firm Registration Number: 311873. Registered in England and
				Wales at: 98 Liverpool Road, Formby, Merseyside, L37 6BS (Company Number: 01636368)
			</Typography>
		),
	},
	{
		title: 'Contact Us',
		content: (
			<Typography>
				To get in touch, please{' '}
				<Typography
					component='a'
					href='https://www.mypolicy.co.uk/get-in-touch/'
					target='_blank'
					sx={{ color: 'white' }}
				>
					click here.
				</Typography>
			</Typography>
		),
	},
	{
		title: 'Privacy Notice',
		content: (
			<Typography
				component='a'
				href='https://www.acorninsure.co.uk/docs/mypolicy/080602-Retail-privacy-notice.pdf'
				target='_blank'
				sx={{ color: 'white' }}
			>
				Our Privacy Notice.
			</Typography>
		),
	},
];

const Copy = {
	keepingInformed: (
		<>
			My Policy and affiliated companies in our Group would like to occasionally contact you to tell you about new
			products, special offers and promotions, so you don&apos;t miss out. Further information can be found in our{' '}
			<HyperLink href='https://www.mypolicy.co.uk/privacy-policy/' target='_blank' rel='noreferrer'>
				Privacy Notice
			</HyperLink>
			. If you&apos;d prefer not to hear from us, please tick the relevant boxes below.
		</>
	),
};

export default Copy;
